import React from 'react';
import Slider from "react-slick";
import { getArrayLength, getArray } from '../../../utils/helpers';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import dish1 from '../../../assets/dish/1_Sea_Urchin_Tomato.jpg';
import dish2 from '../../../assets/dish/2_Prawn_Zucchini_and_Saffron.jpg';
import dish3 from '../../../assets/dish/3_Aoriika_Squid_with_Potato_Onion.jpg';
import dish4 from '../../../assets/dish/4_Tuna_Beetroot.jpg';
import dish5 from '../../../assets/dish/5_Eggplant_Caviar_and_Basil.jpg';
import dish6 from '../../../assets/dish/6_Scallop_Celeriac.jpg';
import dish7 from '../../../assets/dish/7_Tagliolini_Matsutake_Mushrooms.jpg';
import dish8 from '../../../assets/dish/8_Ravioli_Pumpkin_and_Parmigiano_Reggiano.jpg';
import dish9 from '../../../assets/dish/9_Risotto_Carnaroli_Horse_Mackerel_and_Manganji_Chili_Peppers.jpg';
import dish10 from '../../../assets/dish/10_Amadai_Pescatore_Crab.jpg';
import dish11 from '../../../assets/dish/11_Hokkaido_Venison_Grapes.jpg';
import dish12 from '../../../assets/dish/12_Cinta_Senese_with_Chestnut.jpg';
import dish13 from '../../../assets/dish/13_Grandmother_Fig.jpg';
import dish14 from '../../../assets/dish/14_Citrus.jpg';
import dish15 from '../../../assets/dish/15_Latte.jpg';

const DishCard = ({ title, id = '', info }) => {
    const dishes = {
        1: dish1,
        2: dish2,
        3: dish3,
        4: dish4,
        5: dish5,
        6: dish6,
        7: dish7,
        8: dish8,
        9: dish9,
        10: dish10,
        11: dish11,
        12: dish12,
        13: dish13,
        14: dish14,
        15: dish15,
    };

    return (
        <div className="testimonial-item p-6">
            <div className="testimonial-box transition-shadow duration-300 flex flex-col md:flex-row items-center gap-6">
                <div className="flex items-center justify-center">
                    <div className="relative w-[200px] h-[200px] rounded-full overflow-hidden border-4 border-white shadow-lg">
                        <img
                            src={dishes[id]}
                            alt={title}
                            className="object-cover"
                        />
                    </div>
                </div>
                <div>
                    <span className="profile-info">
                        <strong className="profile-name block font-bold text-[#1F0707] font-['Libre_Caslon_Display'] text-[28px] font-normal leading-[28.8px] text-center mb-4">{title}</strong>
                    </span>
                    <div className="comment-content">
                        <p className="text-[26px] text-[#1F07079E] font-['Libre_Caslon_Display'] italic font-normal leading-[36.4px] mb-[35px] text-center">{`"${info}"`}</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

const Dish = ({t}) => {
    const { dishs } = t;
    const settings = {
        arrows: false,
        dots: false,
        lazyLoad: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
    };

    if (getArrayLength(dishs) === 0) return null;
    
    return (
        <section className="bg-[#FFF] py-16">
            <div className="container mx-auto px-4">
                <Slider {...settings}>
                    {getArray(dishs).map((dish, index) => (
                        <div key={index}>
                            <DishCard {...dish} />
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Dish;
